export class Address {
    public Country: string;
    public City: string;
    public District: string;
    public Street: string;
    public ZipCode: string;
    public DisplayText: string;
}